export default __webpack_public_path__ + "static/media/A1.a8c0e634.png";